var map = {
	"./de-de.po": 1967,
	"./en-ca.po": 1968,
	"./en-gb.po": 1969,
	"./en-ie.po": 1970,
	"./en-us.po": 1971,
	"./es-es.po": 1972,
	"./es-mx.po": 1973,
	"./fr-ca.po": 1974,
	"./fr-fr.po": 1975,
	"./hr-hr.po": 1976,
	"./it-it.po": 1977,
	"./nl-nl.po": 1978,
	"./pl-pl.po": 1979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1940;
module.exports = webpackContext;